import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';

import { ViajeTrasladoCanceledTable } from '../components/TableCanceled';
import { FunctionComponent, useRef } from 'react';
import { createTableScrollHandler } from 'utils/tableUtils';

interface ViajeTrasladoCanceladosPageProps {
  onMarkTravelCancelCheck: (id: number) => Promise<boolean>;
  travels: any[];
  highlightedId: number | null;
}

const ViajeTrasladoCanceladosPage: FunctionComponent<
  ViajeTrasladoCanceladosPageProps
> = ({ onMarkTravelCancelCheck, highlightedId, travels }) => {
  const tableRef = useRef<HTMLDivElement>(null);
  /*
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    Mucho de este componente esta copiado en ViajeTrasladoMapPage.
    Si se hace algun cambio revisar que no se tenga que hacer tambien en ViajeTrasladoMapPage.

    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    */

  return (
     <div ref={tableRef}>
      <div
        className="sticky top-0 right-0 left-0 flex flex-col"
        style={{
          zIndex: 101,
          background: '#EAEDF5',
          // border: '1px solid rgba( 255, 255, 255, 0.18 )',
          backdropFilter: 'blur(4px)'
        }}
      >
        <PageHeader area="Operaciones - C.D.R." title="Cancelados App" />
      </div>

      <PageContainer lessMargin>
        <div className="w-full">
          <ViajeTrasladoCanceledTable
            handlePageChange={createTableScrollHandler(tableRef)}
            onLocationsDetails={(reservation) => {}}
            onShowDriverDetails={(driver) => {}}
            travels={travels}
            onMarkTravelCancelCheck={onMarkTravelCancelCheck}
            highlightedId={highlightedId}
          />
        </div>
      </PageContainer>
    </div>
  );
};

export default ViajeTrasladoCanceladosPage;
